import { render, staticRenderFns } from "./editPurchaseRequisition.vue?vue&type=template&id=3f8bd552&scoped=true"
import script from "./editPurchaseRequisition.vue?vue&type=script&lang=js"
export * from "./editPurchaseRequisition.vue?vue&type=script&lang=js"
import style0 from "./editPurchaseRequisition.vue?vue&type=style&index=0&id=3f8bd552&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8bd552",
  null
  
)

export default component.exports